import { render, staticRenderFns } from "./routesmanage.vue?vue&type=template&id=f7d18936&scoped=true&"
import script from "./routesmanage.vue?vue&type=script&lang=js&"
export * from "./routesmanage.vue?vue&type=script&lang=js&"
import style0 from "./routesmanage.vue?vue&type=style&index=0&id=f7d18936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d18936",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7d18936')) {
      api.createRecord('f7d18936', component.options)
    } else {
      api.reload('f7d18936', component.options)
    }
    module.hot.accept("./routesmanage.vue?vue&type=template&id=f7d18936&scoped=true&", function () {
      api.rerender('f7d18936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/routesmanage.vue"
export default component.exports